import React from 'react';
import { CustomParagraph } from '../../../../components';
import {
  ChevronDownIcon,
  ChevronUpIcon,
} from '../../../../assets/icons/icons.jsx';

interface AdvancedSettingsToggleProps {
  isOpen: boolean;
  onToggle: () => void;
  subtitle?: string;
  children?: React.ReactNode;
}

const AdvancedSettingsToggle: React.FC<AdvancedSettingsToggleProps> = ({
  isOpen,
  onToggle,
  subtitle = 'Evaluation tuning',
  children,
}) => (
  <div className='advanced-settings-section'>
    <button
      type='button'
      className='advanced-settings-toggle'
      aria-expanded={isOpen}
      onClick={onToggle}
    >
      <CustomParagraph
        text='Advanced settings'
        fontSize='14px'
        fontWeight={600}
        color='var(--text-primary)'
        marginBottom={0}
      />
      {isOpen ? (
        <ChevronUpIcon size={16} color='var(--text-primary)' />
      ) : (
        <ChevronDownIcon size={16} color='var(--text-primary)' />
      )}
    </button>
    {!isOpen && (
      <div className='advanced-settings-divider' aria-hidden='true' />
    )}
    {isOpen && (
      <div className='advanced-settings-panel'>
        {subtitle ? (
          <CustomParagraph
            text={subtitle}
            fontSize='13px'
            fontWeight={600}
            color='var(--text-secondary)'
            marginBottom={12}
          />
        ) : null}
        <div className='advanced-settings-fields'>{children}</div>
      </div>
    )}
  </div>
);

export default AdvancedSettingsToggle;
